interface BookmarkStickerProps {
  color?: "red" | "yellow" | "green" | "blue";
  position?: "left" | "right";
  onClick?: () => void;
}

const colorMap: Record<string, string> = {
  red: "bg-red-500",
  yellow: "bg-yellow-400",
  green: "bg-green-500",
  blue: "bg-blue-500",
};

export const BookmarkSticker = ({ color = "red", position = "right", onClick }: BookmarkStickerProps) => {
  const positionClass = position === "left" ? "-left-0" : "-right-0";
  
  return (
    <div
      className={`absolute ${positionClass} top-0 z-30 cursor-pointer transition-transform hover:scale-110`}
      onClick={onClick}
      style={{ pointerEvents: 'auto' }}
    >
      {/* Bookmark ribbon shape */}
      <div className="relative">
        <div
          className={`h-20 w-8 shadow-lg ${colorMap[color]}`}
          style={{
            clipPath: 'polygon(0 0, 100% 0, 100% 85%, 50% 100%, 0 85%)',
          }}
        />
        {/* Shine effect */}
        <div
          className="absolute inset-0 bg-gradient-to-r from-white/30 to-transparent"
          style={{
            clipPath: 'polygon(0 0, 100% 0, 100% 85%, 50% 100%, 0 85%)',
          }}
        />
      </div>
    </div>
  );
};
